import Vue from 'vue';
import ApplicationsCountByCategory from '@/plugins/graphql/queries/v2/b2b/applications-count-by-category.gql';
/**
 * Applications Count By Category Query
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.22.0}
 */
export default Vue.extend({
    apollo: {
        applicationsCountByCategory: {
            query: ApplicationsCountByCategory,
            variables() {
                return {
                    appUuid: this.appUuid,
                    category: this.category,
                };
            },
            update(data) {
                return data.partnershipApplicationsByCategory.totalCount;
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
        category: {
            // Cast Prop Type to TS typings
            // @see https://frontendsociety.com/using-a-typescript-interfaces-and-types-as-a-prop-type-in-vuejs-508ab3f83480
            type: String,
            required: true,
        },
    },
    data() {
        return {
            applicationsCountByCategory: 0,
        };
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                count: this.applicationsCountByCategory,
            });
        }
    },
});
